var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.isFormValid,
                    callback: function($$v) {
                      _vm.isFormValid = $$v
                    },
                    expression: "isFormValid"
                  }
                },
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: _vm.tituloModal } },
                        [
                          _vm._t("prependInformacionGeneral"),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm12: "", md12: "" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  label: _vm.formFields.activo.label,
                                  color: "success",
                                  "persistent-hint": "",
                                  hint: _vm.mensajeEstado,
                                  readonly: _vm.modoVer
                                },
                                on: { change: _vm.cambioEstadoSwitch },
                                model: {
                                  value: _vm.formFields.activo.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.activo,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.activo.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm12: "", md12: "" } },
                            [
                              _c("CampoUnico", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value:
                                      "required|max:80|" + _vm.uniqueFieldRule,
                                    expression:
                                      "`required|max:80|${uniqueFieldRule}`"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.nombre.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.nombre.id
                                  ),
                                  "data-vv-name": _vm.formFields.nombre.id,
                                  counter: "80",
                                  disabled: _vm.modoVer,
                                  validate: _vm.validarNombre,
                                  message:
                                    "Ya existe un Certificado con este nombre"
                                },
                                model: {
                                  value: _vm.formFields.nombre.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.nombre,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.nombre.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", sm6: "", md6: "" } },
                            [
                              _c("v-select", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.tipo.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.tipo.id
                                  ),
                                  "data-vv-name": _vm.formFields.tipo.id,
                                  items: _vm.lstTipoCertificados,
                                  "item-text": "nombre",
                                  "item-value": "id",
                                  disabled: _vm.modoVer
                                },
                                on: { change: _vm.handlerChangeTipo },
                                model: {
                                  value: _vm.formFields.tipo.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.tipo, "value", $$v)
                                  },
                                  expression: "formFields.tipo.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", sm6: "", md6: "" } },
                            [
                              _c("v-select", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.firma.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.firma.id
                                  ),
                                  "data-vv-name": _vm.formFields.firma.id,
                                  items: _vm.lstFirmaCertificados,
                                  "item-text": "nombre",
                                  "item-value": "id",
                                  disabled: _vm.modoVer
                                },
                                on: { change: _vm.handlerChangeFirma },
                                model: {
                                  value: _vm.formFields.firma.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.firma, "value", $$v)
                                  },
                                  expression: "formFields.firma.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", sm6: "", md6: "" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  label: _vm.formFields.expiracion.label,
                                  color: "success",
                                  "persistent-hint": "",
                                  hint: _vm.mensajeEstadoExpiracion,
                                  readonly: _vm.modoVer
                                },
                                on: { change: _vm.cambioEstadoExpiracion },
                                model: {
                                  value: _vm.formFields.expiracion.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.expiracion,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.expiracion.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", sm6: "", md6: "" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  label: _vm.formFields.qr.label,
                                  color: "success",
                                  "persistent-hint": "",
                                  hint: _vm.mensajeEstadoQr,
                                  readonly: _vm.modoVer
                                },
                                on: { change: _vm.cambioEstadoQr },
                                model: {
                                  value: _vm.formFields.qr.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.qr, "value", $$v)
                                  },
                                  expression: "formFields.qr.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm12: "", md12: "" } },
                            [
                              _vm.imageUrl
                                ? _c("img", {
                                    attrs: {
                                      src: _vm.imageUrl,
                                      height: "83",
                                      alt: "Logo Tercero"
                                    }
                                  })
                                : _vm._e(),
                              _c("v-text-field", {
                                attrs: {
                                  label: "Seleccione Logo Mandante.",
                                  heigh: "",
                                  "prepend-icon": "attach_file",
                                  readonly: "readonly"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.$refs.image.click()
                                  }
                                },
                                model: {
                                  value: _vm.imageName,
                                  callback: function($$v) {
                                    _vm.imageName = $$v
                                  },
                                  expression: "imageName"
                                }
                              }),
                              _c("input", {
                                key: _vm.idkey,
                                ref: "image",
                                staticStyle: { display: "none" },
                                attrs: {
                                  type: "file",
                                  accept: "image/png, image/jpeg",
                                  readonly: _vm.modoVer
                                },
                                on: { change: _vm.onFilePicked }
                              })
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }